<template>
    <router-link class='resourceTile cs-burnt-orange' :to="{name: 'resourcesearch',  query: { tag: tag.title }}">
        <div class='resourceTileInner'>
        <img :src='tag.thumbnail.url'>
        <div class='resourceText'><h2>{{tag.title}}</h2><h3> </h3></div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['tag']
}
</script>